import React, { Component } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import DeliveryCard from "./DeliveryCard";

import Cart from "./Cart";

import { connect } from "react-redux";
import { Form, FormControl } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import InputGroup from "react-bootstrap/InputGroup";

class DeliveryMenu extends Component {

    state = {
        search: ''
    };

    handleChange = (e) => {
        this.setState({ search: e.target.value.toUpperCase() })
    };


    itemsIterate = (meal) => {
        return Object.values(this.props.items)
            .filter(item =>
                item.meal === meal && (item.title.toUpperCase().includes(this.state.search) || item.description.toUpperCase().includes(this.state.search) || item.price.toUpperCase().includes(this.state.search))
            ).map(item => this.cardRender(item));
    };

    cardRender = (item) => <DeliveryCard img={item.img} title={item.title} price={item.price} num={item.num} />;

    render() {
        const appetizer = this.itemsIterate('appetizer'),
            main = this.itemsIterate('main'),
            desert = this.itemsIterate('desert');

        return (
            <Container className='Delivery'>

                <Form className='justify-content-center' inline>
                    <InputGroup style={{ width: "30%" }}>
                        <FormControl onChange={this.handleChange} type="text" placeholder='Search Your Menu Items' />
                        <InputGroup.Append>
                            {/* <InputGroup.Text id="inputGroupPrepend">
                                <FaSearch />
                            </InputGroup.Text> */}
                        </InputGroup.Append>
                    </InputGroup>
                </Form>

                {appetizer.length > 0 &&
                    <>
                        <Row className='pb-3'>
                            {appetizer}
                        </Row>
                    </>}

                {main.length > 0 &&
                    <>
                        <h1 className='pt-5 mx-auto'>Main Course</h1>
                        <Row className='pb-3'>
                            {main}
                        </Row>
                    </>}


                {desert.length > 0 &&
                    <>
                        <h1 className='pt-5 mx-auto'>Main Course</h1>
                        <Row className='pb-3'>
                            {desert}
                        </Row>
                    </>}

                {(desert.length === 0 && main.length === 0 && appetizer.length === 0) &&
                    <div className='text-center mt-5'>
                        <h4>
                            Your search didn't match any item
                        </h4>
                    </div>
                }

            </Container>
        );
    }
}

const mapStateToProps = (state) => {
    
    return {
        items: state.cart.items
        // 'Fried Tiger Shrimp Rolls': {
        //     num: 0,
        //     img: 'https://media1.fdncms.com/riverfronttimes/imager/u/original/2633986/sushi_house_white_tiger.jpg',
        //     title: 'Fried Tiger Shrimp Rolls',
        //     price: '6.50',
        //     description: 'with a plum sauce',
        //     meal: 'appetizer'
        // },
        // 'Thai Spare Ribs': {
        //     num: 0,
        //     img: 'https://static01.nyt.com/images/2017/08/16/dining/16kitchenrex/16Kitchen-recs-articleLarge.jpg',
        //     title: 'Thai Spare Ribs',
        //     price: '8.95',
        //     description: 'glazed and grilled pork ribs',
        //     meal: 'appetizer'
        // },
        // 'Gai Pad Khing': {
        //     num: 0,
        //     img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Kai_phat_khing.jpg/250px-Kai_phat_khing.jpg',
        //     title: 'Gai Pad Khing',
        //     price: '7.95',
        //     description: 'sauteed sliced chicken with mushrooms, peppers, cabbage, carrots and onions in a fresh ginger sauce',
        //     meal: 'appetizer'
        // },
        // 'Nuur Kra Prow': {
        //     num: 0,
        //     img: 'https://assets.tmecosys.com/image/upload/t_web767x639/img/recipe/ras/Assets/EA260A79-7F93-4F6E-B587-A6C9AE1F4FDB/Derivates/8f2988c1-bc54-4806-b4a8-62d2dbfc8db8.jpg',
        //     title: 'Nuur Kra Prow',
        //     price: '8.50',
        //     description: 'sauteed sliced beef with peppers, cabbage, carrots and onions in a chili basil sauce',
        //     meal: 'appetizer'
        // },
        // 'Koong Pad Khing': {
        //     num: 0,

        //     img: 'https://highheelgourmet.files.wordpress.com/2014/01/stir-fried-shrimp-with-green-bean-and-chili-paste-pad-phrik-khing-goong-6.jpg',
        //     title: 'Koong Pad Khing',
        //     price: '8.95',
        //     description: 'sauteed shrimp with mushrooms, peppers, cabbage, carrots and onions in a fresh ginger sauce',
        //     meal: 'appetizer'
        // },
        // 'Gai Kratiam': {
        //     num: 0,
        //     img: 'https://www.truetasteofthai.com/wp-content/uploads/2017/02/13.Gai-Kratiem-1-1-0-945x486.jpg',
        //     title: 'Gai Kratiam',
        //     price: '7.95',
        //     description: 'sauteed sliced chicken with broccoli, cabbage and onions in a fresh garlic sauce',
        //     meal: 'appetizer'
        // },
        // }
    }
};

export default connect(mapStateToProps)(DeliveryMenu);